import React, { useEffect, useState, useContext } from "react";
import { CheckCircleFill, PrinterFill } from "react-bootstrap-icons";
import { useParams } from "react-router-dom";
import api from "../admin/api/api";
import { ShopContext } from "../context/ShopContext";
import "./OrderSuccess.scss";

function OrderSuccess() {
    const { orderId } = useParams();
    const { shop } = useContext(ShopContext);

    console.log(orderId);

    const [order, setOrder] = useState(null);

  useEffect(() => {
  if (orderId) {
    getOrderDetails();
  }
}, [orderId]);

  const getOrderDetails = async () => {

    try {
      const response = await api.get(`/Orders/${orderId}`);
      setOrder(response.data);

    } catch (error) {
      console.log(error);
    }

  };

  if (!order) {
    return <h2>Loading...</h2>;
  }

  const printInvoice = () => {
    window.print();
  };

  return (
    <div className="order-success-container">

      <div className="success-card">

        {/* Success Icon */}
        <div className="success-header border-bottom pb-3 border-2">
          <CheckCircleFill className="success-icon" />
          <h2>Order Placed Successfully!</h2>
          <p>Thank you for shopping with {shop?.shopName}.</p>
        </div>

        {/* Order Info */}
        <div className="order-info">

          <div className="order-box">
            <p><strong>Order Number</strong></p>
            <span>#{order.orderNo}</span>
          </div>

          <div className="order-box">
            <p><strong>Order Date</strong></p>
            <span>{order.orderDate}</span>
          </div>

          <div className="order-box">
            <p><strong>Total Amount</strong></p>
            <span>₹{order.totalAmount}</span>
          </div>

        </div>

        {/* Address */}
        <div className="address-section">
          <h4>Delivery Address</h4>

          <p>{order.customerName}</p>
          <p>{order.address}</p>
          <p>{order.city}</p>
          <p>{order.mobile}</p>

        </div>

        {/* Product List */}
        <div className="product-section">

          <h4>Ordered Products</h4>

          <table className="product-table">
            <thead>
              <tr>
                <th>Product</th>
                <th>Qty</th>
                <th>Price</th>
                <th>Size</th>
                <th>Color</th>
              </tr>
            </thead>

            <tbody>
              {order.items.map((item, index) => (
                <tr key={index}>
                  <td>{item.productName}</td>
                  <td>{item.qty}</td>
                  <td>₹{item.price}</td>
                  <td>{item.size}</td>
                  <td>{item.color}</td>
                </tr>
              ))}
            </tbody>

          </table>

        </div>
       
        {/* Buttons */}
        <div className="action-buttons1">
            <a href={`/invoice/${order.orderId}`} className="btnsuccess invoice-btn">
               <PrinterFill /> Print Invoice
            </a> 
          

          <a href="/" className="btnsuccess continue-btn">
            Continue Shopping
          </a>

        </div>

      </div>

    </div>
  );
}

export default OrderSuccess;